export default __webpack_public_path__ + "static/media/linkedin.f80f2b9e.svg";